import React from 'react';
import { Redirect } from 'react-router-dom';
import ui from 'redux-ui';
import moment from 'moment-timezone';
import ReactTable from "react-table";

import { PageTitle } from '../PageTitle';
import { CompletedChecklistService, TimeFormattingService } from '../../services';
import i18next from "i18next";

class CompletedChecklistDetail extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      checklist: null,
      checklistId: props.match.params.completedChecklistId,
      errorMessage: null
    };
  }

  componentDidMount() {
    CompletedChecklistService.get(this.state.checklistId).then((response) => {
      this.setState({ checklist: response.checklist, timezone: response.checklist.deviceGrouping ? response.checklist.deviceGrouping.timezone : null});
    }).catch((error) => {
      this.setState({ errorMessage: i18next.t('messages.could-not-load-checklist') });
      console.error(error);
    });
  }

  render() {
    if (this.state.errorMessage) {
      return (
          <Redirect to={{
            pathname: '/monitoring/checklists',
            state: {
              errorMessage: this.state.errorMessage
            }
          }}/>
      );
    }

    if (this.state.checklist) {
      return <ChecklistDetail checklist={this.state.checklist} timezone = {this.state.timezone} />;
    } else {
      return (
          <div className="loader">{ i18next.t('loading') }</div>
      );
    }
  }

}

class ChecklistDetail extends React.Component {
  render() {

    return (
        <div>
          <div className="row">
            <PageTitle title={this.props.checklist.checklistConfig.name}
                       backLink="/monitoring/checklists" />
          </div>

          <div className="op-content-box">
            <div className="row">
              <div className="col-sm-6 form-group">
                <div className="card-data-cell remove-border-left card-data-cell-icon card-icon-description">
                  <label>{ i18next.t('pages.checklists.start-time') }</label>
                  <p>{TimeFormattingService.renderNormalTime(this.props.checklist.startTime, this.props.timezone)}</p>
                </div>
              </div>
              <div className="col-sm-6 form-group">
                <div className="card-data-cell remove-border-left card-data-cell-icon card-icon-description">
                  <label>{ i18next.t('pages.checklists.end-time') }</label>
                  <p>{TimeFormattingService.renderNormalTime(this.props.checklist.endTime, this.props.timezone)}</p>
                </div>
              </div>

            </div>
          </div>
          <div className="op-content-box">
            <h4 className="remove-margin-bottom">{ i18next.t('pages.completed-checklists.completed-items') }</h4> <br/>

            <ChecklistItemList items = { this.props.checklist.completedChecklistItems } />

          </div>
        </div>
    );
  }
}

@ui({
  key: 'checklist-item-list',
  persist: true,
  state: {
    prevPage: null
  }
})
class ChecklistItemList extends React.Component {

  // TODO handle timezone correctly
  // TODO handle more than just numeric values

  columnsDef = [
    { data: 'checklistItemConfig.name' },
    { data: 'checklistItemConfig.areaTag', render: ( data, type, row, meta ) => data ? data.name : 'None' },
    { data: 'readingTime', render: ( data, type, row, meta ) => moment(data).format("L LTS zz") },
    { data: 'value', render: ( data, type, row, meta ) => sprintf("%0.2f F", (data * 1.8) + 32) }
  ];

  constructor(props) {
    super(props);

  }

  setupTable() {
    //value will be set to either numeric or string, whichever is not null
    for (var i = 0; i < this.props.items.length; i++) {
      this.props.items[i].value = this.props.items[i].numericValue ? this.props.items[i].numericValue : this.props.items[i].stringValue
    }
  }

  componentDidMount() {
    this.setupTable();
  }

  render() {
    this.setupTable();
    return (
      <div className="react-table-custom">
      <ReactTable
        className="-striped -highlight"
        ref="checklistTable"
        data={this.props.items}

        showPaginationTop
        pivotBy={["area"]}
        columns={[
                    {
                      Header: i18next.t('table-headers.name'),
                      accessor: "checklistItemConfig.name",
                      aggregate: vals => "",
                      sortable: false,
                      minResizeWidth: 50
                    },
                    {
                      Header: i18next.t('table-headers.area'),
                      id: "area",
                      accessor: row => row.checklistItemConfig.areaTag ? row.checklistItemConfig.areaTag.name : 'None',
                      sortable: false,
                      minResizeWidth: 50
                    },
                    {
                      Header: i18next.t('table-headers.time-reading-taken'),
                      id: "timeTaken",
                      accessor: row => TimeFormattingService.renderNormalTime(row.readingTime, null),
                      aggregate: vals => "",
                      sortable: false,
                      minResizeWidth: 50
                    },
                    {
                      Header: i18next.t('table-headers.reading'),
                      id: "reading",
                      accessor:row => sprintf("%0.2f F", (row.value * 1.8) + 32),
                      aggregate: vals => "",
                      sortable: false,
                      minResizeWidth: 50
                    }
                  ]}
      />
      </div>
    );
  }
}

export default CompletedChecklistDetail;
